<template>
  <div
    class="modal-card"
    :class="{ 'modal-card-scrollable': !isScrollable, 'is-responsive': isResponsive }"
    :style="{ width }"
    :data-e2e="dataE2e"
  >
    <slot name="custom" />
    <header class="modal-card-head" :class="{ 'no-header': !$slots.header }">
      <slot name="header" />
      <span
        v-if="closeInModal"
        @click="onClickCloseButton"
        class="icon cls cls-remove close-button is-size-5"
        :class="{ 'no-header': !$slots.header }"
        :data-e2e="ModalCypressAttribute.buttons.CLOSE_IN_MODAL"
      ></span>
    </header>
    <section
      class="modal-card-body"
      :class="{
        'modal-card-body-scrollable': !isScrollable,
        'no-header': !$slots.header
      }"
      v-if="$slots.body"
    >
      <slot name="body" />
    </section>
    <footer class="modal-card-foot" v-if="$slots.footer">
      <slot name="footer" />
    </footer>
  </div>
</template>
<script>
import { ModalCypressAttribute } from '@/modules/core/app/constants/ModalCypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ModalCard',
  emits: ['on-click-close-button'],
  slotsDefinition: {
    custom: {},
    header: {},
    body: {},
    footer: {}
  },
  props: {
    isScrollable: {
      type: Boolean,
      default: true
    },
    isResponsive: {
      type: Boolean,
      default: false
    },
    dataE2e: {
      type: String,
      required: false
    },
    closeInModal: {
      type: Boolean,
      default: false
    },
    width: {
      type: String
    },
    closeConfirmFn: {
      type: Function,
      required: false
    }
  },
  static: {
    ModalCypressAttribute
  },
  methods: {
    async onClickCloseButton() {
      if (this.closeConfirmFn && !(await this.closeConfirmFn())) {
        return;
      }

      this.$emit('on-click-close-button');
      this.$parent.close?.();
    }
  }
};
</script>

<style scoped>
.modal-card {
  width: 100%;
}

.close-button {
  cursor: pointer;
}

header {
  font-size: var(--ce-18px);
  font-weight: bolder;

  &.no-header {
    height: var(--ce-1px);
    padding: var(--ce-5px);
  }
}

div.modal-card-scrollable {
  overflow: unset !important;
  overflow-y: visible !important;
}

section.modal-card-body-scrollable {
  overflow: unset !important;
}

section.modal-card-body {
  background-color: var(--ce-white) !important;
  color: var(--ce-black) !important;
}

footer.modal-card-foot {
  background-color: var(--ce-white) !important;
  color: var(--ce-black) !important;
}

.modal-card-head {
  color: var(--ce-black) !important;
}

.modal-card.is-responsive {
  width: 100%;
  .modal-card-head {
    padding-bottom: 0;
  }

  @media (max-width: CE_MOBILE) {
    width: 90%;
  }

  @media (min-width: CE_MOBILE) and (max-width: CE_TABLET) {
    width: 60%;
  }

  @media (min-width: CE_TABLET) and (max-width: CE_WIDESCREEN) {
    width: 50%;
  }

  @media (min-width: CE_WIDESCREEN) and (max-width: CE_FULLHD) {
    width: 40%;
  }

  @media (min-width: CE_FULLHD) {
    width: 40%;
  }
}

@media (max-width: CE_MOBILE) {
  .modal-card-head {
    padding: var(--ce-18px) var(--ce-20px);
    height: var(--ce-75px);
  }
  .close-button {
    &.no-header {
      position: absolute;
      top: var(--ce-28px);
      right: var(--ce-25px);
    }
  }

  header {
    &.no-header {
      height: 0 !important;
      padding: 0 !important;
    }
  }
  .modal-card-head.no-header {
    border-bottom: none !important;
  }
}
</style>
